<script setup lang="ts">

import RingPlanetOre from '@/components/Sections/Resources/Elements/RingPlanetOre.vue'
import { useOreConversionStore } from '@/stores/oreConversionStore.ts'

const oreConversionStore = useOreConversionStore()

const debug = false
</script>

<template>
  <RingPlanetOre
    v-if="oreConversionStore.data.planetRingWorldToKarmasas.capacity > 0 || oreConversionStore.data.planetRingWorldToNadzerbat.capacity > 0"
    :planetType="8"
    :oreLeft="13"
    :oreRight="14"
    :conversionLeft="oreConversionStore.data.planetRingWorldToKarmasas"
    :conversionRight="oreConversionStore.data.planetRingWorldToNadzerbat"
    :top="43"
    :left="12.5"
    :debug="debug"
  ></RingPlanetOre>


  <RingPlanetOre
    v-if="oreConversionStore.data.planetRingWorldToGalagores.capacity > 0 || oreConversionStore.data.planetRingWorldToMiout.capacity > 0"
    :planetType="8"
    :oreLeft="15"
    :oreRight="16"
    :conversionLeft="oreConversionStore.data.planetRingWorldToGalagores"
    :conversionRight="oreConversionStore.data.planetRingWorldToMiout"
    :top="43"
    :left="52.5"
    :debug="debug"
  ></RingPlanetOre>


  <RingPlanetOre
    v-if="oreConversionStore.data.planetRingWorldToLdwarts.capacity > 0 || oreConversionStore.data.planetRingWorldToMankazor.capacity > 0"
    :planetType="8"
    :oreLeft="17"
    :oreRight="18"
    :conversionLeft="oreConversionStore.data.planetRingWorldToLdwarts"
    :conversionRight="oreConversionStore.data.planetRingWorldToMankazor"
    :top="43"
    :left="92.5"
    :debug="debug"
  ></RingPlanetOre>
</template>

<style scoped lang="scss">

</style> 